// extracted by mini-css-extract-plugin
export default {"DoubleImage":"DoubleImage-module__DoubleImage--ty1JO"};